const increase = document.querySelector(".sun__increase");
const decrease = document.querySelector(".sun__decrease");
const temperature = document.querySelector(".sun__celcius--number");
const wheather = document.querySelector(".sun__celcius--wheader");
const arrow = document.querySelector(".sun__arrow");
const sunPoints = document.querySelectorAll(".sun__point");
//sun elements
const deg0 = document.querySelector(".deg0");
const deg15 = document.querySelector(".deg15");
const deg30 = document.querySelector(".deg30");
const deg150 = document.querySelector(".deg150");
const deg165 = document.querySelector(".deg165");
const deg180 = document.querySelector(".deg180");
const deg195 = document.querySelector(".deg195");
const deg210 = document.querySelector(".deg210");
const deg225 = document.querySelector(".deg225");
const deg240 = document.querySelector(".deg240");
const deg255 = document.querySelector(".deg255");
const deg270 = document.querySelector(".deg270");
const deg285 = document.querySelector(".deg285");
const deg300 = document.querySelector(".deg300");
const deg315 = document.querySelector(".deg315");
const deg330 = document.querySelector(".deg330");
const deg345 = document.querySelector(".deg345");

//variables
let counter = 23;
let arrowPosition = 285;
let celciusText = "warm";
increase.addEventListener("click", () => {
  counter++;
  arrowPosition = arrowPosition + 15;
  displayTemerature();
  blockButton();
  checkSun();
});
decrease.addEventListener("click", () => {
  counter--;
  arrowPosition = arrowPosition - 15;
  displayTemerature();
  blockButton();
  checkSun();
});

function displayTemerature() {
  temperature.innerHTML = `${counter}°C `;
  counter > 19 ? (celciusText = "warm") : (celciusText = "cool");
  wheather.innerHTML = celciusText;
  arrow.style.transform = `rotate(${arrowPosition}deg) translate(100px) rotate(90deg)`;
}

function blockButton() {
  if (counter >= 30) {
    increase.disabled = true;
  } else {
    increase.disabled = false;
  }

  if (counter <= 14) {
    decrease.disabled = true;
  } else {
    decrease.disabled = false;
  }
}

function checkSun() {
  sunPoints.forEach((point) => {
    if (point.dataset.temp <= counter) {
      point.style.backgroundColor = "#328291";
    } else {
      point.style.backgroundColor = "#fff";
    }
  });
}
checkSun();
